"use client";

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { BLUR_PLACEHOLDER } from '@/lib/componentutills';
type DistrictNameImageProps = {
  text?: string;
  className?: string;
  backgroundImage?: string;
};
export default function DistrictNameImage(t0) {
  const $ = _c(8);
  const {
    text: t1,
    className: t2,
    backgroundImage: t3
  } = t0;
  const text = t1 === undefined ? "\u0B9A\u0BC6\u0BA9\u0BCD\u0BA9\u0BC8" : t1;
  const className = t2 === undefined ? "" : t2;
  const backgroundImage = t3 === undefined ? "https://media.dinamani.com/dinamani/2026-02-27/f2gd0nem/DistrictImage.png" : t3;
  const t4 = `relative w-full h-32 ${className}`;
  let t5;
  if ($[0] !== backgroundImage) {
    t5 = <Image src={backgroundImage} alt="Background" fill={true} className="object-cover" sizes="(max-width: 425px) 70vw, (max-width: 768px) 100vw, (max-width: 1250px) 80vw, 1400px" loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} />;
    $[0] = backgroundImage;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== text) {
    t6 = <div className="absolute inset-0 grid grid-cols-3 items-center justify-center mx-2xl px-8"><h2 className="text-012061 md:text-16-tamil-500 text-32-tamil-500 grid justify-center">{text}</h2></div>;
    $[2] = text;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t4 || $[5] !== t5 || $[6] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}